<template>
  <v-container fluid class="acc-booking pa-0">
    <v-navigation-drawer permanent
                         expand-on-hover>
      <v-list dense>
        <v-list-item :to="{name: 'acc-booking-dashboard'}" v-if="$hasPermission('acc.dashboard')">
          <v-list-item-icon>
            <v-icon>mdi-gauge</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.dashboard') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-booking-booking'}" v-if="$hasPermission('acc.list_booking')" link>
          <v-list-item-icon>
            <v-icon>mdi-file-document-edit-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.booking') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-booking-recurrent-booking'}" v-if="$hasPermission('acc.list_booking')" link>
          <v-list-item-icon>
            <v-icon>mdi-file-document-refresh-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.recurrent_booking') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-booking-purchase-order'}" v-if="$hasPermission('acc.manage_purchase_order')" link>
          <v-list-item-icon>
            <v-icon>mdi-cart-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.purchase_order') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-booking-invoice'}" v-if="$hasPermission('acc.manage_purchase_order')" link>
          <v-list-item-icon>
            <v-icon>mdi-receipt-text</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.invoice') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-booking-facility'}" v-if="$hasPermission('acc.setup_facility')" link>
          <v-list-item-icon>
            <v-icon>mdi-home-city-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.facility') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-gym'}" v-if="$hasPermission('acc.setup_facility')" link>
          <v-list-item-icon>
            <v-icon>mdi-dumbbell</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.gym') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-package'}" v-if="$hasPermission('acc.setup_facility')" link>
          <v-list-item-icon>
            <v-icon>mdi-gift</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.package') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-discount-code'}" v-if="$hasPermission('acc.manage_discount_code')" link>
          <v-list-item-icon>
            <v-icon>mdi-sale-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.discount_code') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-coupon-group'}" v-if="$hasPermission('acc.manage_coupon')" link>
          <v-list-item-icon>
            <v-icon>mdi-ticket</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.coupon_group') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-email-template'}" v-if="$hasPermission('acc.email_templates')" link>
          <v-list-item-icon>
            <v-icon>mdi-email-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc.email_templates') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-report'}" v-if="$hasPermission('acc.reports')" link>
          <v-list-item-icon>
            <v-icon>mdi-file-find-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.report') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-public-holiday'}" v-if="$hasPermission('acc.public_holidays')" link>
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc_public_holiday.title') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'acc-white-card'}" v-if="$hasPermission('acc.white_cards')" link>
          <v-list-item-icon>
            <v-icon>mdi-qrcode</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_acc_white_card.title') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <router-view class="acc-booking-admin-main"></router-view>

<!--    <v-container fluid>-->
<!--      <router-view></router-view>-->
<!--    </v-container>-->
  </v-container>
</template>

<script>
export default {
  name: 'AccBooking',
  components: {},
  data() {
    return {
      tabIndex: 0,
      selectedEventId: null,
      selectedSessionId: null,
    };
  },
  mounted() {

  },
  computed: {
    isAdmin() {
      return this.$store.state.user.type === 369;
    },
  },
  methods: {
    updateRoute(override) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          t: this.tabIndex,
          e: this.selectedEventId,
          s: this.selectedSessionId,
          ...override,
        },
      })
    },
    tabChanged(tabIndex) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {...this.$route.query, t: tabIndex}
      })
    },
  },
}
</script>

<style lang="less">
.acc-booking {
  height: 100%;
  display: flex;

  .acc-booking-admin-nav {
    width: 20%;
    height: 100%;
    overflow-y: auto;

    display: flex;
    flex-direction: column;

    border-right: 1px solid lightgrey;

    a {
      font-size: 1.5em;
      font-weight: bold;
      text-decoration: none;
      // margin-left: 30px;
      margin: 10px 0;
      color: #a4a4a4;

      &.router-link-active {
        color: #62cbd0 !important;
        font-weight: bolder;
      }
    }

  }

  .acc-booking-admin-main {
    overflow: scroll;
  }
}
</style>
